var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconArrowRight = function SvgIconArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--colors-brand)",
    d: "m12.997 4.438 5.074 4.941c.317.309.347.8.087 1.144l-.079.09-5.082 4.95a.958.958 0 0 1-1.333 0 .906.906 0 0 1-.017-1.283l3.444-3.354H2.595a.927.927 0 1 1 0-1.853l12.496-.001-3.427-3.336a.905.905 0 0 1-.017-1.282l.017-.016a.954.954 0 0 1 1.333 0z",
    fillRule: "evenodd"
  })));
};

export default SvgIconArrowRight;